import React from 'react';
import PropTypes from 'prop-types';

import {
  withAssetLibraryServicesLoaded,
  withCopilotDataServiceLoaded,
} from '@bingads-webui-campaign-react/asset-library-services';
import { FolderAssetType } from '@bingads-webui-campaign-react/asset-library-model';

import { VideoEditorWithAddImageWrapper } from './video-editor-with-add-image-wrapper';

const VideoEditorWithDataServices = withCopilotDataServiceLoaded(withAssetLibraryServicesLoaded(VideoEditorWithAddImageWrapper, { loggerTag: 'Asset Library Tab' }));

export const CopilotVideoEditor = (props) => {
  const {
    assetLibraryConfig,
    permissions,
    isAADUser,
    isLiteLandingPageEnabled,
    isOpen,
    setIsOpen,
    videoMetaData,
    onApply,
    cid,
    aid,
    finalUrl,
    perfMarker,
    i18n,
    isCTV,
  } = props;

  // todo: don't pilot AAD user for now, remove this check after the feature is GAed
  const isAssetLibraryAIGCMVPEnabled = !isAADUser;

  const {
    timeZone,
    preferencesService,
    activityLogger,
    oDataConfig,
    dateFormat,
  } = assetLibraryConfig;

  return (
    isOpen ?
      <VideoEditorWithDataServices
        accountTimeZone={timeZone}
        preferenceService={preferencesService}
        activity={activityLogger}
        assetLibraryConfig={assetLibraryConfig}
        oDataConfig={oDataConfig}
        allowedAssetType={FolderAssetType.Image}
        isAssetLibraryAIGCMVPEnabled={isAssetLibraryAIGCMVPEnabled}
        isLiteLandingPageEnabled={isLiteLandingPageEnabled}
        dateFormat={dateFormat}
        permissions={permissions}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        videoMetaData={videoMetaData}
        onApply={onApply}
        cid={cid}
        aid={aid}
        finalUrl={finalUrl}
        perfMarker={perfMarker}
        i18n={i18n}
        isCTV={isCTV}
      /> : null
  );
};

CopilotVideoEditor.propTypes = {
  assetLibraryConfig: PropTypes.shape({
    timeZone: PropTypes.number,
    preferencesService: PropTypes.shape({}),
    activityLogger: PropTypes.shape({}),
    oDataConfig: PropTypes.shape({}),
    dateFormat: PropTypes.string,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  videoMetaData: PropTypes.shape().isRequired,
  onApply: PropTypes.func.isRequired,
  cid: PropTypes.string.isRequired,
  aid: PropTypes.string.isRequired,
  finalUrl: PropTypes.string.isRequired,
  perfMarker: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  isAADUser: PropTypes.bool,
  isLiteLandingPageEnabled: PropTypes.bool,
  isCTV: PropTypes.bool,
};

CopilotVideoEditor.defaultProps = {
  isLiteLandingPageEnabled: false,
  isAADUser: false,
  isCTV: false,
};
